import * as React from 'react';

const Box32 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#Box32__a)" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#007782", d: "M9 9h15v4h-1v10H10V13H9z" }), /* @__PURE__ */ React.createElement("path", { fill: "#C9F0EE", d: "M17 19h3.5v1.5H17z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "Box32__a" }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h32v32H0z" }))));
Box32.Size = 32;
Box32.Title = "Box";

export { Box32 as default };
